import React from "react";
import Tabs from '../Tabs/Tabs';
import ModalButtons from "../ModalButtons/ModalButtons"
import LoadingSpinner from "../LoadingSpinner/LoadingSpinner";
import CashDrawerBuilderErrors from "./CashDrawerBuilderErrors"
import CashDrawerBuilderWorkspace from "./CashDrawerBuilderWorkspace";

export default class CashDrawerBuilder extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      active_tab: 'general',
      cash_drawer: this.props.cash_drawer,
      errors: [],
      loading: false
    }

    this.onSave = this.onSave.bind(this)
    this.onChange = this.onChange.bind(this)
    this.onChangeActiveTab = this.onChangeActiveTab.bind(this)
  }

  /**
   * Render functions
   */

  render() {
    // console.log('CashDrawerBuilder', this.props)

    return (
      <div className="CashDrawerBuilder">
        <Tabs tabs={this.renderTabs()} />
        <div className="panel panel-form">
          <CashDrawerBuilderWorkspace {...this.state} onChange={this.onChange} />
          <LoadingSpinner show={this.state.loading} />
          <ModalButtons loading={this.state.loading} buttons={this.renderButtons()} />
        </div>
      </div>
    )
  }

  renderButtons() {
    return [
      {
        name: I18n.t('cancel'),
        html_attributes: [
          'data-dismiss="modal"'
        ],
      },
      {
        name: I18n.t('submit'),
        button_classes: ['primary', 'modal-footer', 'btn-primary', 'submit-buttons'],
        onClick: (e) => {
          this.onSave();
        }
      },
    ];
  }

  renderTabs() {
    return [
      {
        tabName: I18n.t('general'),
        targetName: 'general',
        classes: this.state.active_tab === 'general' ? 'active' : null,
        changeHandler: this.onChangeActiveTab,
        tabErrorCount: CashDrawerBuilderErrors.general(this.state.errors).length
      },
    ]
  }

  /**
   * Change handlers
   */

  onChange(event) {
    var cash_drawer = {...this.state.cash_drawer}
    cash_drawer[event.target.name] = event.target.value
    //console.log('onChange', event.target.name, event.target.value, cash_drawer)
    this.setState({
      cash_drawer: cash_drawer
    })
  }

  onChangeActiveTab(name) {
    this.setState({active_tab: name})
  }

  /**
   * Helper functions
   */

  onSave() {
    this.setState({loading: true})

    $.ajax({
      type: 'POST',
      url: this.props.save_path,
      data: {
        cash_drawer: this.state.cash_drawer,
      },
    }).done((data) => {
      if (data.success) {
        this.setState({loading: false})
        parent.refresh_data()
        parent.hide_modal()
      } else if (data.errors) {
        this.setState({
          loading: false,
          errors: data.errors,
        });
      };
    });
  }

}
